/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { ofType, StateObservable } from 'redux-observable';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import { Action, ActionCreators } from './actions';
import { RootState } from '../index';
import { handleErrorInterceptor } from '../../utils/AuthUtils';

const requestFlightLegServiceAlertsSuccess = (response: AjaxResponse<any>): any => {
  return ActionCreators.ReceivedFlightLegServiceAlertsSuccess.create({ response });
};

const requestFlightLegServiceAlertsError = (error: AjaxError): any => {
  const errorMessage = error.message !== undefined ? error.message : 'Error requesting Flight Leg Service Alerts';
  return ActionCreators.ReceivedFlightLegServiceAlertsError.create({ error: errorMessage });
};

const requestServiceAlertsSuccess = (response: AjaxResponse<any>): any => {
  return ActionCreators.ReceivedServiceAlertsSuccess.create({ response });
};

const requestServiceAlertsError = (error: AjaxError): any => {
  const errorMessage = error.message !== undefined ? error.message : 'Error requesting Flight Leg Service Alerts';
  return ActionCreators.ReceivedServiceAlertsError.create({ error: errorMessage });
};

export const getFlightLegServiceAlertsEpic = (
  action$: Observable<Action>,
  state$: StateObservable<RootState>,
  { ajaxRaw }: any,
): Observable<Action> =>
  action$.pipe(
    ofType(ActionCreators.RequestFlightLegServiceAlerts.type),
    switchMap(
      ($action: any): Observable<Action> =>
        ajaxRaw
          .getWithHeaders(`/mpt/flightlegs/${$action.payload.flightLegId}/servicealertsallusers`, {
            missionPlanId: $action.payload.missionPlanId,
            userid: $action.payload.userid,
          })
          .pipe(
            map(
              (response: AjaxResponse<any>): Action =>
                requestFlightLegServiceAlertsSuccess(response),
            ),
            catchError(
              (error: AjaxError): Observable<Action> =>
                handleErrorInterceptor(
                  error,
                  of(requestFlightLegServiceAlertsError(error))
                ),
            ),
          ),
    ),
  );

export const getServiceAlertsEpic = (
  action$: Observable<Action>,
  state$: StateObservable<RootState>,
  { ajaxRaw }: any,
): Observable<Action> =>
  action$.pipe(
    ofType(ActionCreators.RequestServiceAlerts.type),
    mergeMap(
      ($action: any): Observable<Action> =>
        ajaxRaw
          .getWithHeaders(`/mpt/flightlegs/${$action.payload.flightLegId}/servicealerts`, {
            missionPlanId: $action.payload.missionPlanId,
            userid: $action.payload.userid,
          })
          .pipe(
            map((response: AjaxResponse<any>): Action => requestServiceAlertsSuccess(response)),
            catchError(
              (error: AjaxError): Observable<Action> =>
                handleErrorInterceptor(
                  error,
                  of(requestServiceAlertsError(error))
                ),
            ),
          ),
    ),
  );
